// ==================================================
//  Special Movie 再生制御
// ==================================================
const movieImage = document.querySelector('.js-recruitment-movieImage');
const movieVideo = document.querySelector('.js-recruitment-movieVideo');

// Ensure video is hidden initially
movieVideo.style.display = 'none';

// Fullscreen handler
function openFullscreen(video) {
  if (video.requestFullscreen) {
    video.requestFullscreen();
  } else if (video.webkitRequestFullscreen) {
    video.webkitRequestFullscreen();
  } else if (video.mozRequestFullScreen) {
    video.mozRequestFullScreen();
  } else if (video.msRequestFullscreen) {
    video.msRequestFullscreen();
  }
}

// Click thumbnail to show and play video fullscreen
movieImage.addEventListener('click', () => {
  movieVideo.style.display = 'block';
  movieVideo.currentTime = 0;
  movieVideo.play();
  openFullscreen(movieVideo);
});

// Detect exiting fullscreen
function onFullscreenChange() {
  const fullscreenElement =
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement;

  if (!fullscreenElement) {
    // Hide the video and pause when not in fullscreen
    movieVideo.pause();
    movieVideo.style.display = 'none';
  }
}

document.addEventListener('fullscreenchange', onFullscreenChange);
document.addEventListener('webkitfullscreenchange', onFullscreenChange);
document.addEventListener('mozfullscreenchange', onFullscreenChange);
document.addEventListener('MSFullscreenChange', onFullscreenChange);

// 動画クリック時は一時停止/再生のトグル（終了はEscキーまたはブラウザのフルスクリーン終了のみ）
movieVideo.addEventListener('click', (e) => {
  e.preventDefault();
  e.stopPropagation();
  if (movieVideo.paused) {
    movieVideo.play();
  } else {
    movieVideo.pause();
  }
});

// ==================================================
//  募集要項 タブ
// ==================================================
document.addEventListener('DOMContentLoaded', () => {
  const tabItems01 = Array.from(document.querySelectorAll('.js-recruitmentTabItem01'));
  const contentItems01 = Array.from(document.querySelectorAll('.js-recruitmentContentItem01'));
  const tabItems02 = Array.from(document.querySelectorAll('.js-recruitmentTabItem02'));
  const contentItems02 = Array.from(document.querySelectorAll('.js-recruitmentContentItem02'));

  // 01グループ
  tabItems01.forEach((tab, idx) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      // Remove active class from all tabs and contents in group 01
      tabItems01.forEach((t) => t.classList.remove('is-active'));
      contentItems01.forEach((c) => c.classList.remove('is-active'));

      // Add active class to the clicked tab and corresponding content
      tab.classList.add('is-active');
      if (contentItems01[idx]) {
        contentItems01[idx].classList.add('is-active');
      }
    });
  });

  // 02グループ
  tabItems02.forEach((tab, idx) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      // Remove active class from all tabs and contents in group 02
      tabItems02.forEach((t) => t.classList.remove('is-active'));
      contentItems02.forEach((c) => c.classList.remove('is-active'));

      // Add active class to the clicked tab and corresponding content
      tab.classList.add('is-active');
      if (contentItems02[idx]) {
        contentItems02[idx].classList.add('is-active');
      }
    });
  });
});
